import React from 'react'
import { Link } from 'react-router-dom';

function YearSelector({years, year, setYear, month}) {

    function columnFormatter(arr) {
        const numCols = Math.floor(12/(arr.length))
        return numCols;

    }

    return (
        <div className="col-12 my-3">
            <div className="row">
                {years?.map((currentYear, index) => {
                    return (
                        <div className={`col-3 col-md-2 col-lg-${columnFormatter(years)} mb-2`} key={index}>
                            <Link to={`/?item=1&year=${currentYear}&month=${month.number}`} className={year === currentYear ? "bg-primary text-white button" : "bg-light button"} onClick={() => setYear(currentYear)}>{currentYear}</Link>
                        </div>
                    )
                })}
            </div>
        </div>
    )

}
export default YearSelector